import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Logininfo } from '../classes/Loginifo'
import { AuthService } from '../Services/auth.service';
import { ListService } from '../Services/list.service';
import { SearchTopService } from '../Services/search-top.service';
import { SearchService } from '../Services/search-condition.service';
import { MatchingService } from '../Services/matching.service';
import { CustomerInputService } from '../Services/customer-input.service';
import * as constant from '../constant';
import { ScService } from '../search-data/sc.service';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css']
})
export class CustomerListComponent implements OnInit {
  logininfo: Logininfo = this.authService.loginID;
  customerList: any;
  templateList: any;
  selectTemplate: any = '';
  sc = this.scService.sc;

  status: any = constant.status;
  status2: any = constant.status2;
  ranks: any = constant.ranks;
  ranks_ob: any = constant.ranks_ob;

  constructor(
    private scService: ScService,
    private router: Router,
    public authService: AuthService,
    private list: ListService,
    public customerInputService: CustomerInputService,
    public matchingService: MatchingService,
    private templateService: SearchTopService,
    private searchService: SearchService
  ) { }

  ngOnInit() {
    this.getTempalteList();
  }

  getCustomer() {
    this.customerList = [];

    this.list.getCustomerList(this.logininfo.user_code, null
    ).subscribe((data: any) => {
      data.forEach((cst) => {
        let name = cst.customer_name;
        let kana = cst.kana_name;
        this.customerList.push({
          customer_code: cst.customer_code,
          customer_name: name,
          customer_kana: kana,
          status: cst.status
        });
      });
    });
  }

  getTempalteList() {
    this.templateService.getTemplateList(this.logininfo.authority_code).subscribe(result => {
      //console.log('selectedDivision', result);
      this.templateList = result;
      this.selectTemplate = '';
      if (this.templateList.length > 0) {
        this.selectTemplate = this.templateList[0].search_condition_code;
        this.selectedTemplate();
      }
    });
  }

  selectedTemplate() {
    //console.log('selectedTemplate', this.selectTemplate);
    this.templateService.getCondition(this.selectTemplate, this.logininfo.division_code, this.logininfo.user_code).subscribe(result => {
      this.sc = result['search_condition'];
      this.searchService.getSearchData(this.sc).subscribe(list => {
        this.customerList = list;
        //console.log('selectedTemplate list', this.customerList);
      });
    });
  }

  //顧客詳細へ
  customerDetail(id) {
    this.scService.sc = this.sc;
    this.matchingService.br_flg = false;
    this.customerInputService.ip_flg = false;
    this.router.navigate(['/detail/' + id]);
  }

}
